import { useState } from "react";
import axios from "axios";
import { useAuth } from "../context/AuthContext";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const API = axios.create({
  baseURL: API_BASE_URL,
});

// Attach token + handle FormData Content-Type in one interceptor
API.interceptors.request.use((config) => {
  const token = localStorage.getItem("accessToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // If sending FormData, let the browser set Content-Type with the correct boundary.
  // Manually setting it (even to "multipart/form-data") breaks the boundary and multer fails.
  if (config.data instanceof FormData) {
    delete config.headers["Content-Type"];
    delete config.headers["content-type"];
  } else {
    // All non-FormData requests use JSON
    config.headers["Content-Type"] = "application/json";
  }

  return config;
});

const useApi = () => {
  const [loading, setLoading] = useState(false);
  const { logout } = useAuth();

  const callApi = async ({ endpoint, method = "GET", data = null, params = null, headers = {} }) => {
    setLoading(true);
    try {
      const response = await API({
        url: endpoint,
        method,
        data,
        params,
        headers,
      });

      return response.data;
    } catch (error) {
      if (error.response && error.response.message === "Expired authorization token.") {
        logout();
      }
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return { callApi, loading };
};

export default useApi;
